import {
  buildSection,
  DetailTable,
  EmptyDetail,
  formatCurrency,
  humanizeEnum,
  yesNo,
  type DetailSection,
} from "./detailPrimitives";

// supplemental (accident, critical_illness) — renders supplemental_plan_config.
export function SupplementalBenefitBlock({ config }: { config: any }) {
  if (!config) return <EmptyDetail />;

  const coverageAmountDisplay = (() => {
    switch (config.coverageAmountType) {
      case "flat_amount":
        return formatCurrency(config.flatCoverageAmount);
      case "earnings_multiple":
        return config.earningsMultiple != null
          ? `${Number(config.earningsMultiple)}× ${humanizeEnum(config.earningsBase)}`
          : "—";
      default:
        return humanizeEnum(config.coverageAmountType);
    }
  })();

  const sections = [
    buildSection("Coverage", [
      { label: "Benefit Schedule", value: humanizeEnum(config.benefitScheduleType) },
      { label: "Coverage Amount", value: coverageAmountDisplay },
      { label: "Minimum", value: formatCurrency(config.minimumCoverage) },
      { label: "Maximum", value: formatCurrency(config.maximumCoverage) },
      { label: "Increment", value: formatCurrency(config.coverageIncrement) },
      { label: "Guaranteed Issue", value: formatCurrency(config.guaranteedIssueAmount) },
    ]),
    buildSection("Features", [
      { label: "Portability", value: yesNo(config.portabilityAllowed) },
      { label: "Conversion", value: yesNo(config.conversionAllowed) },
    ]),
  ].filter(Boolean) as DetailSection[];

  return <DetailTable sections={sections} />;
}
